export default {
  FISCHMAUL_FUSSBODENHEIZUNG: 815,
  FISCHMAUL_NORMAL: 348,
  ENDPFOSTEN: 2537,
  MITTELPFOSTEN: 2538,
  ECKPFOSTEN: 2539,
  HANDLAUF: 2371,
  STAPLERBARRIERE: 2223,
}